import { __assign } from 'tslib';
import * as React from 'react';
import { UitkLayoutSizes } from 'uitk-react-layout';
import { classNames } from 'uitk-react-utils';
import { UitkLayoutFlexItemAlignSelfs, EgdsSizingLengths } from './types.esm.js';
import styles from './uitk-layout-flex.css';

var getClassNameList = classNames.bind(styles);
var UitkLayoutFlexItem = function (props) {
    var alignSelf = props.alignSelf, className = props.className, maxWidth = props.maxWidth, minWidth = props.minWidth, grow = props.grow, shrink = props.shrink, style = props.style;
    /**
     * Check string is a valid EgdsSizingLength value
     *
     * @param size {string} - size
     * @returns EgdsSizingLengths.includes(size as EgdsSizingLength)
     */
    var IsEgdsSize = function (size) { return EgdsSizingLengths.includes(size); };
    var childrenArray = React.Children.toArray(props.children);
    var firstChild = childrenArray[0];
    if (!firstChild || typeof firstChild !== 'object' || !('props' in firstChild)) {
        return null;
    }
    var firstChildClassName = firstChild.props.className;
    var firstChildStyle = firstChild.props.style;
    var baseClass = 'uitk-layout-flex-item';
    /**
     * Return a valid className for minWidth or maxWidth
     *
     * @param prop {typeof minWidth | typeof maxWidth} - prop
     * @param prefix {"flex-basis" | "max-width"} - className prefix
     * @returns string
     */
    var lengthClassName = function (prop, prefix) {
        return prop && typeof prop === 'string' && "".concat(baseClass, "-").concat(prefix, "-").concat(IsEgdsSize(prop) ? prop : UitkLayoutSizes.get(prop));
    };
    var wrapperClassNames = getClassNameList(alignSelf && "".concat(baseClass, "-").concat(UitkLayoutFlexItemAlignSelfs.get(alignSelf)), baseClass, firstChildClassName, lengthClassName(maxWidth, 'max-width'), lengthClassName(minWidth, 'flex-basis'), typeof grow !== 'undefined' && Number.isInteger(grow) && "".concat(baseClass, "-flex-grow-").concat(grow), typeof shrink !== 'undefined' && Number.isInteger(shrink) && "".concat(baseClass, "-flex-shrink-").concat(shrink), className);
    var wrapperStyle = __assign(__assign(__assign(__assign({}, firstChildStyle), style), (minWidth &&
        typeof minWidth === 'number' && {
        flexBasis: "".concat(minWidth, "px")
    })), (maxWidth &&
        typeof maxWidth === 'number' && {
        maxInlineSize: "".concat(maxWidth, "px")
    }));
    var decoratedChild = React.cloneElement(firstChild, __assign({ className: wrapperClassNames }, (Object.keys(wrapperStyle).length && {
        style: wrapperStyle
    })));
    return decoratedChild;
};
UitkLayoutFlexItem.displayName = 'UitkLayoutFlexItem';

export { UitkLayoutFlexItem };
